module.exports = __webpack_public_path__ + "static/media/targetx_green_x.aeec5ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/views/images/targetx_green_x.png
// module id = 254
// module chunks = 0